import { form, errors } from '../state'
import { CONTENT_TYPES } from '../../../constants/suggestions'

/**
 * Form verilerini başlangıç değerleriyle doldurur
 * @param {Object} contentProps - İçerik özellikleri
 */
export const initForm = (contentProps) => {
  // Form alanlarını sıfırla
  form.suggestion = ''
  form.currentText = ''

  // İçerik tipine göre varsayılan değerler
  form.currentImageUrl = contentProps.contentType === CONTENT_TYPES.IMAGE
      ? contentProps.currentImageUrl || ''
      : ''

  form.currentVideoUrl = contentProps.contentType === CONTENT_TYPES.VIDEO
      ? contentProps.currentVideoUrl || ''
      : ''

  form.priority = 3

  // Hata mesajlarını temizle
  Object.keys(errors).forEach(key => errors[key] = '')
}
